import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    minHeight: "inherit",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
}));

export default styles;
